export const toggleModal = "toggleModal"
export const ADD_POINT_TO_LIST = "ADD_POINT_TO_LIST"
export const UPDATE_POINTS_IN_LIST = "UPDATE_POINTS_IN_LIST"
export const DELETE_POINTS_FROM_LIST = "DELETE_POINTS_FROM_LIST"
export const ADD_POINTS_TO_LIST = "ADD_POINTS_TO_LIST"
export const GROUP_BY_CATEGORIES_WITH_SUB_CATEGORIES = "GROUP_BY_CATEGORIES_WITH_SUB_CATEGORIES"
export const GROUP_BY_EMPLOYEES_WITH_ROLES = "GROUP_BY_EMPLOYEES_WITH_ROLES"
export const ADD_LEADERBOARD_POINTS_TO_LIST = "ADD_LEADERBOARD_POINTS_TO_LIST"
export const ADD_ALL_TIME_LEADERBOARD_POINTS_TO_LIST = "ADD_ALL_TIME_LEADERBOARD_POINTS_TO_LIST"
export const ADD_SINGLE_POINT_TO_LEADERBOARD_POINT_LIST = "ADD_SINGLE_POINT_TO_LEADERBOARD_POINT_LIST"
export const ADD_MY_POINTS_OVERVIEW = "ADD_MY_POINTS_OVERVIEW"
export const SUBTRACT_REDEEM_REQUEST_FROM_MY_WALLET_POINTS = "SUBTRACT_REDEEM_REQUEST_FROM_MY_WALLET_POINTS"




